const InteractionText = {
    // ENEM
    enemWelcome: (totalTime) =>
        (`Como você sabe é preciso passar no ENEM para entrar na UFJF, e sua prova começa agora! \n\n ` +
            `Você precisa ter um aproveitamento mínimo de 60% para ser aprovado. Caso seja reprovado terá que esperar 5 minutos para fazer a prova novamente. \n\n` +
            `Você terá ${totalTime} minutos para fazer a prova, então cuidado para não ficar sem tempo. ` +
            `Boa sorte!`),

    enemSuccess: (correctCount, totalCount, points) =>
        (`Olá, Parabéns! \n\n ` +
            `Você passou no ENEM para a UFJF!\n\n` +
            `Você acertou ${correctCount} das ${totalCount} questões da prova.\n\n` +
            `Conseguiu uma nota de ${points}.`),

    enemFail: (correctCount, totalCount, points) =>
        (`Olá!\n\n ` +
            `Infelizmente você não atingiu o resultado mínimo para entrar na UFJF.\n\n` +
            `Você acertou apenas ${correctCount} das ${totalCount} questões.\n\n` +
            `Sua nota do ENEM foi ${points}.\n\n` +
            `Tente realizar a prova do ENEM novamente em breve.\n\n`),

    // TEST
    testWelcome: (totalTime) =>
        (`A prova da nossa disciplina será hoje. Espero que você esteja preparado. \n\n` +
            `Você terá ${totalTime} minutos para responder. Espero que seja suficiente. \n\n` +
            `Boa prova!`),

    testComplete: (correctCount, totalCount, correctPercentage) =>
        (`Olá!\n\n ` + `Este é o resultado da sua prova.\n\n` +
            `Você acertou ${correctCount} das ${totalCount} questões.\n\n` +
            `Conseguiu uma nota de ${correctPercentage}%.`),

    testIncomplete: (answeredCount, correctCount, totalCount, correctPercentage) =>
        (`Olá!\n\n ` + `Este é o resultado da sua prova.\n\n` +
            `Você respondeu ${answeredCount} ` +
            `de um total de ${totalCount} e acertou ${correctCount}.\n\n` +
            `Conseguiu uma nota de ${correctPercentage}%.`),

    // OPPORTUNITY TEST
    opportunityTestWelcome: (totalTime) =>
        (`Como você sabe, para conseguir a vaga será necessário passar nesta prova. \n\n` +
            `Você terá ${totalTime} minutos para responder. Espero que seja suficiente. \n\n` +
            `Boa prova!`),

    opportunityTestComplete: (correctCount, totalCount, correctPercentage) =>
        (`Olá!\n\n ` + `Este é o resultado da sua prova.\n\n` +
            `Você acertou ${correctCount} das ${totalCount} questões.\n\n` +
            `Conseguiu uma nota de ${correctPercentage}%.`),

    opportunityTestIncomplete: (answeredCount, correctCount, totalCount, correctPercentage) =>
        (`Olá!\n\n ` + `Este é o resultado da sua prova.\n\n` +
            `Você respondeu ${answeredCount} ` +
            `de um total de ${totalCount} questões e acertou ${correctCount}.\n\n` +
            `Conseguiu uma nota de ${correctPercentage}%.`),

    // EXERCISES
    exercisesWelcome: (totalTime) =>
        (`Você já fez aquela lista de exercícios?\n\n` +
            `Fiquei sabendo que ela vai ajudar muito nas provas, você não deveria deixar para a última hora. \n\n` +
            `Terminei a minha em ${totalTime} ` +
            `minutos. Quer apostar que você consegue fazer mais rápido? ;)`),

    exercisesPerfect: (totalCount) =>
        (`Olá!\n\n ` +
            `O professor conferiu os seus exercícios e estão perfeitos!.\n\n` +
            `Todas as ${totalCount} questões do seu gabarito estavam corretas :D`),

    exercisesNotPerfect: (wrongCount, totalCount) =>
        (`Olá!\n\n ` +
            `O professor conferiu seus exercícios.\n\n` +
            `Você errou ${wrongCount} das ${totalCount} questões.\n\n` +
            `Vamos estudar mais? :(`),

    // EXERCISES HELP
    exercisesHelpWelcome: (totalTime) =>
        (`Você pode me ajudar com esses exercícios?\n\n` +
            `Não estou entendendo nada e você é minha última esperança! \n\n` +
            `Sei que você não está com muito tempo, mas podemos nos encontrar por ` +
            `${totalTime} minutos na hora do almoço.`),

    exercisesHelpPerfect: (totalCount) =>
        (`O professor conferiu os exercícios e estão perfeitos!\n\n` +
            `Todas as ${totalCount} questões do seu gabarito estavam corretas!\n\n` +
            `Obrigado pela ajuda! Vou te procurar mais vezes`),

    exercisesHelpNotPerfect: (wrongCount, totalCount) =>
        (`Olá!\n\n ` +
            `O professor conferiu os exercícios.\n\n` +
            `Você errou ${wrongCount} das ${totalCount} questões.\n\n` +
            `Mesmo assim, obrigado pela ajuda.`),

    // TEST CORRECTION
    testCorrectionWelcome: (numberOfQuestions, totalTime) =>
        (`Bom dia professor! \n\n` +
            `Eu e outros alunos estamos aguardando o resultado das provas. \n\n` +
            `Poderia nos enviar o gabarito? \n\n` +
            `Como foram apenas ${numberOfQuestions} questões, acredito que você não ` +
            `vai demorar mais que ${totalTime} minutos para corrigir.`),

    testCorrectionPerfect: (totalCount) =>
        (`Olá!\n\n ` +
            `Conferi nos livros e concordo totalmente com a sua correção.\n\n` +
            `Todas as ${totalCount}  questões do seu gabarito estão corretas`),

    testCorrectionNotPerfect: (wrongCount, totalCount) =>
        (`Olá!\n\n ` +
            `Conferi nos livros e a correção da minha prova não está totalmente certa.\n\n` +
            `Você errou a correção de ${wrongCount} das ${totalCount}  questões.\n\n` +
            `Acho que mereço uma nota maior!`),

    // TEST CORRECTION HELP
    testCorrectionHelpWelcome: (numberOfQuestions, totalTime) =>
        (`Boa tarde! \n\n` +
            `Fiquei sabendo que você poderá me ajudar a corrigir as provas, muito obrigado pela ajuda. \n\n` +
            `A prova não é muito grande, apenas ${numberOfQuestions} questões.\n\n` +
            `Mesmo não sendo sua especialidade, acredito que você não vai demorar mais de ` +
            totalTime + ` minutos para corrigir.`),

    testCorrectionHelpPerfect: (totalCount) =>
        (`Olá!\n\n ` +
            `Conferi nos livros e concordo totalmente com a sua correção.\n\n` +
            `Todas as ${totalCount}  questões do seu gabarito estão corretas`),

    testCorrectionHelpNotPerfect: (wrongCount, totalCount) =>
        (`Olá!\n\n ` +
            `Conferi nos livros e a correção da minha prova não está totalmente certa.\n\n` +
            `Você errou a correção de ${wrongCount} das ${totalCount}  questões.\n\n` +
            `Acho que mereço uma nota maior!`),

    // PRESENTATION
    presentationWelcome: (totalTime) =>
        (`Consegui marcar sua apresentação para hoje! \n\n` +
            `Mas você terá apenas ${totalTime} minutos para falar. \n\n` +
            `Escolha bem o que vai dizer!`),

    presentationPerfect: () =>
        (`Parabéns pela apresentação!\n\n ` +
            `Você falou de forma brilhante e não discordo de nada que você disse. \n\n` +
            `Espero assistir mais apresentações suas! \n\n`),

    presentationNotPerfect: () =>
        (`Parabéns pela apresentação, ` +
            `mas conferi nos livros e algumas coisas que você disse não estão corretas.\n\n` +
            `Prepare-se melhor para próxima vez que for se apresentar.`),

    // PRESENTATION HELP
    presentationHelpWelcome: (totalTime) =>
        (`Bom dia! \n\n` +
            `Obrigado por fazer essa apresentação por mim. \n\n` +
            `A apresentação não precisa ser muito grande, ${totalTime} minutos serão suficientes. \n\n`),

    presentationHelpPerfect: () =>
        (`Parabéns pela apresentação!\n\n ` +
            `Você falou de forma brilhante e não discordo de nada que você disse. \n\n` +
            `Espero assistir mais apresentações suas! \n\n`),

    presentationHelpNotPerfect: () =>
        (`Parabéns pela apresentação, ` +
            `mas conferi nos livros e algumas coisas que você disse não estão corretas.\n\n` +
            ` Prepare-se melhor para próxima vez que for se apresentar.`),

    // PRESENTATION CORRECTION
    presCorrectionWelcome: (totalTime) =>
        (`Bom dia! \n\n` +
            `A minha apresentação poderia ser hoje? \n\n` +
            `Consigo terminá-la em apenas ${totalTime} minutos. Não vou tomar muito do seu tempo. \n\n`),

    presCorrectionPerfect: () =>
        (`Olá!\n\n ` +
            `Conferi nos livros e concordo totalmente com a sua correção.\n\n` +
            `Obrigado por participar da minha avaliação. Suas sugestões vão me ajudar muito!`),

    presCorrectionNotPerfect: (wrongCount) =>
        (`Olá!\n\n ` +
            `Conferi nos livros e a correção de minha apresentação não está totalmente certa.\n\n` +
            `Você errou ${wrongCount} vezes. `),

    // PRESENTATION CORRECTION HELP
    presCorrectionHelpWelcome: (totalTime) =>
        (`Bom dia! \n\n` +
            `Obrigado por me ajudar a avaliar essa apresentação. \n\n` +
            `Uma opinião de alguém fora da área vai ser muito importante. \n\n` +
            `A apresentação não será muito grande, ${totalTime} minutos no máximo. \n\n`),

    presCorrectionHelpPerfect: () =>
        (`Olá!\n\n ` +
            `Conferi nos livros e concordo totalmente com a sua correção.\n\n` +
            `Obrigado por participar da minha avaliação. Suas sugestões vão me ajudar muito!`),

    presCorrectionHelpNotPerfect: (wrongCount) =>
        (`Olá!\n\n ` +
            `Conferi nos livros e a correção de minha apresentação não está totalmente certa.\n\n` +
            `Você errou ${wrongCount} vezes. `),

    // GENERIC SESSION
    sessionWelcome: (totalTime) =>
        (`Para avançar, você precisa fazer provas e alcançar o aproveitamento mínimo. \n\n` +
            `Cuidado para não ser reprovado e ganhar menos pontos.\n\n` +
            `Aqui, você terá ${totalTime} minutos para responder todas as questões.\n\n` +
            `Boa prova!`),

    sessionComplete: (correctCount, totalCount, correctPercentage) =>
        (`Olá!\n\n ` + `Este é o seu resultado.\n\n` +
            `Você acertou ${correctCount} das ${totalCount} questões.\n\n` +
            `Conseguiu uma nota de ${correctPercentage}%.`),

    sessionIncomplete: (answeredCount, correctCount, totalCount, correctPercentage) =>
        (`Olá!\n\n ` + `Este é o seu resultado.\n\n` +
            `Você respondeu ${answeredCount}` +
            ` de um total de ${totalCount}questões e acertou ${correctCount}.\n\n` +
            `Conseguiu uma nota de ${correctPercentage}%.`),
    levelUp: (level) =>
        (`Parabéns!\n\n ` +
            `Você foi aprovado e agora passou para a fase "${level}".\n\n ` +
            `Continue jogando para acumular mais pontos e se destacar!`
        ),

    repeatLevel: (level) =>
        (`Infelizmente sua nota não foi suficiente para a próxima fase. \n` +
            `Você terá que repetir a fase "${level}". \n\n` +
            `Mas não desanime, você tem potencial e só precisa se dedicar um pouco mais!`
        )
};

export default InteractionText;



// WEBPACK FOOTER //
// ./src/views/InteractionViews/interactionText.js